/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';
import { isAuthenticatedUser } from 'js/lib/user';

import { breakpoints } from '@coursera/cds-core';

import ModularOnboardingModuleRenderer from 'bundles/onboarding-common/module-renderers/ModularOnboardingModuleRenderer';
import type { ConsumerPathwayRolePageDataContextType } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRolePageDataContext';
import getQueryString from 'bundles/unified-career-academy/utils/getQueryString';

type Props = {
  pageData: ConsumerPathwayRolePageDataContextType;
};

const styles = {
  container: css`
    .onboardingModule {
      margin-bottom: calc(var(--cds-spacing-600) * -1);

      ${breakpoints.down('xs')} {
        margin-bottom: calc(var(--cds-spacing-400) * -1);
      }
    }
  `,
};

const RdpOnboardingModuleRenderer = ({ pageData }: Props) => {
  const { query } = useLocation();

  if (!isAuthenticatedUser() || !pageData?.careerRoleData?.id || !pageData?.careerRoleData?.name) {
    return null;
  }

  const handleOnboardingCompletionSuccess = () => {
    window.location.assign(`${window.location.pathname}${getQueryString(query, 'completedOnboarding', 'true')}`);
  };

  return (
    <div css={styles.container}>
      <ModularOnboardingModuleRenderer
        entrypoint="RDP"
        inferredRole={{ id: pageData.careerRoleData.id, name: pageData.careerRoleData.name }}
        onOnboardingCompletionSuccess={handleOnboardingCompletionSuccess}
        className="onboardingModule"
      />
    </div>
  );
};

export default RdpOnboardingModuleRenderer;
